import {ChangeDetectionStrategy, Component, computed, Inject, Injectable, input, OnInit, signal, Signal, viewChild} from '@angular/core';
import {EntitetType, GruppeMedlemListeModell, MedlemId, MøteId, ProtokollDetaljerModell, ProtokollførtMøtedeltakereModell, ProtokollførtMøtedeltakerModell, ProtokollTranskripsjonInformasjonModell, SkjemalåsModell, SkjemalåsRessursClient, SkjemalåsSkjemaId, TilgangsrolleMedlem, TynnSakModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {i18n} from "felles-ng2/tjenester/i18n/Oversettelser";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {toObservable, toSignal} from "@angular/core/rxjs-interop";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {BehandlingsstedKomponent} from "web-ng2/delt/komponenter/behandlingssted/behandlingssted";
import {ProtokollførtDeltakerinformasjonKomponent} from "../protokollført-deltakerinformasjon/protokollført-deltakerinformasjon";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {DokumentKortvisningKomponent} from "web-ng2/moduler/dokument/komponenter/dokument-kortvisning/dokument-kortvisning";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {MøteDatatjeneste, MøteModellDLM} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {AgendaelementModellDLM, SakDatatjeneste} from "felles-ng2/tjenester/datalager/SakDatatjeneste";
import {ProtokollførtMøtedeltakereDatatjeneste} from "felles-ng2/tjenester/datalager/ProtokollførtMøtedeltakereDatatjeneste";
import {ProtokollDatatjeneste} from "felles-ng2/tjenester/datalager/ProtokollDatatjeneste";
import {from, Observable, of, switchMap} from "rxjs";
import {tomMøteModell, tomProtokollDetaljerModell, tomProtokollførtMøtedeltakereModell} from "felles-ng2/modell/tommeModeller";
import {harTilgangTilProtokollforslag} from "felles-ng2/modell/transkripsjonModellHjelpere";
import {enkodetEntitetReferanseSpesifikasjon, somEntitetReferanseSpesifikasjon} from "felles-ng2/modell/entitetReferanseSpesifikasjonHjelpere";
import {FormaterZonedDateTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimePipe";
import {FormaterDurationPipe} from "felles-ng2/pipes/FormaterDurationPipe";
import {lesDurationSerialisert} from "felles-ng2/støttefunksjoner/temporal";

import {MøteprotokollSaksreferatKomponent} from "../møteprotokoll-saksreferat/møteprotokoll-saksreferat";
import {MøteprotokollSignatarer, MøteprotokollSignatarerKomponent} from "web-ng2/moduler/møteprotokoll/komponenter/møteprotokoll-signatarer/møteprotokoll-signatarer";
import {erFlerdagsmøte} from "felles-ng2/modell/møteModellHjelpere";
import {TittelHandlingerHøyrestiltKomponent, TittelKomponent, TittelVerdiKomponent, VerdiKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi";
import {TittelVerdiSamlingKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi-samling";
import {ZoneddatetimeSomPlainTimePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainTimePipe";
import {FormaterPlainTimePipe} from "felles-ng2/pipes/FormaterPlainTimePipe";
import {erIkkeTomStreng} from "felles-ng2/støttefunksjoner/strenger";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ajs_AjsUIRouterGlobals_DI_TOKEN, AjsUIRouterGlobals} from "web-ng2/tjenester/ajs/AjsUIRouterGlobals";
import {DelegerteDokumentvisningOperasjoner, DelegerteDokumentvisningOperasjoner_DI_TOKEN} from "web-ng2/moduler/dokument/komponenter/dokumentvisning/DokumentvisningBasisKomponent";
import {DelegerteDokumentMenyOperasjoner, DelegerteDokumentMenyOperasjoner_DI_TOKEN} from "web-ng2/moduler/dokument/komponenter/dokument-meny/dokument-meny";
import {RammeInnholdKomponent, RammeMedTittelKomponent} from "web-ng2/delt/komponenter/ramme-med-tittel/ramme-med-tittel";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {eksterneProtokollførteMøtedeltakere, interneProtokollførteMøtedeltakere} from "felles-ng2/modell/protokollModellHjelpere";
import {MatDrawer, MatDrawerContainer, MatDrawerContent} from "@angular/material/sidenav";
import {DelegerteDokumentDetaljerOperasjoner, DelegerteDokumentDetaljerOperasjoner_DI_TOKEN, DokumentDetaljerKomponent} from "web-ng2/moduler/dokument/komponenter/dokument-detaljer/dokument-detaljer";
import {tomFunksjon} from "felles-ng2/støttefunksjoner/funksjoner";
import {LukkMatDrawerKnappKomponent} from "web-ng2/delt/komponenter/lukk-mat-drawer-knapp/lukk-mat-drawer-knapp";
import {ajs_$rootScope_DI_TOKEN, AjsRootScopeService} from "web-ng2/tjenester/ajs/AjsRootScopeService";
import {MøteKontroller} from "web/moduler/møte/komponenter/møte/møte";
import {scrollTilSenter} from "web-ng2/delt/dom/scrollIntoView";
import {timeoutSomPromise} from "felles-ng2/støttefunksjoner/promiser";
import {C3TodeltPaiKomponent, C3TodeltPaiKonfig} from "../../../../delt/komponenter/c3-todelt-pai/c3-todelt-pai";
import {farge_grå_400_skagastølstind, farge_profil_200_trondheim, farge_profil_500_bergen} from "felles-ng2/fargepalett";
import {MatTooltip} from "@angular/material/tooltip";

const debug = initDebugger('MøteprotokollVisKomponent');

/**
 * Statusen transkripsjonen av møtet vises i, se {@link MøteprotokollVisKomponent.transkripsjonsstatus}.
 *
 * `ingenOpptak` betyr at møtet ikke ble tatt opp, og da vises ingen status i det hele tatt.
 * `ingenTilgangTilProtokollforslag` betyr at bruker er skjermet for noen av sakene i møtet, og dermed ikke får generere
 * eller se forslag til protokoll, se {@link harTilgangTilProtokollforslag}. Da vises heller ingen status.
 */
export type Transkripsjonsstatus =
  'ingenOpptak'
  | 'ingenTilgangTilProtokollforslag'
  | 'transkripsjonFeilet'
  | 'generertProtokollTilgjengelig'
  | 'transkriberingPaagaar'
  | 'venterPaaGenerertProtokoll';

/**
 * Viser møtereferat for møte med angitt id.
 * Merk at vi forventer at møte er lastet av kaller og tilgjengelig i datalager.
 */
@Component({
    selector: 'moeteprotokoll-vis',
    templateUrl: 'møteprotokoll-vis.html',
    styleUrl: 'møteprotokoll-vis.scss',
    host: {'[class.viserProtokolldokumentdetaljer]': 'viserProtokolldokumentdetaljer()'},
    imports: [
        MatButton,
        MatIcon,
        TranslateModule,
        BehandlingsstedKomponent,
        ProtokollførtDeltakerinformasjonKomponent,
        TipsKomponent,
        DokumentKortvisningKomponent,
        ZonedDateTimeSomPlainDatePipe,
        FormaterPlainDatePipe,
        FormaterZonedDateTimePipe,
        FormaterDurationPipe,
        MøteprotokollSaksreferatKomponent,
        MøteprotokollSignatarerKomponent,
        TittelHandlingerHøyrestiltKomponent,
        TittelKomponent,
        TittelVerdiKomponent,
        VerdiKomponent,
        TittelVerdiSamlingKomponent,
        ZoneddatetimeSomPlainTimePipe,
        FormaterPlainTimePipe,
        RammeMedTittelKomponent,
        RammeInnholdKomponent,
        InlineMeldingKomponent,
        MatDrawerContainer,
        MatDrawerContent,
        MatDrawer,
        DokumentDetaljerKomponent,
        LukkMatDrawerKnappKomponent,
        C3TodeltPaiKomponent,
        MatIconButton,
        MatTooltip
    ],
    providers: [
        {provide: DelegerteDokumentDetaljerOperasjoner_DI_TOKEN, useFactory: (komponent: MøteprotokollVisKomponent) => komponent.delegerteDokumentDetaljerOperasjoner(), deps: [MøteprotokollVisKomponent]},
        {provide: DelegerteDokumentvisningOperasjoner_DI_TOKEN, useFactory: (komponent: MøteprotokollVisKomponent) => komponent.delegerteDokumentvisningOperasjoner(), deps: [MøteprotokollVisKomponent]},
        {provide: DelegerteDokumentMenyOperasjoner_DI_TOKEN, useFactory: (komponent: MøteprotokollVisKomponent) => komponent.delegerteDokumentMenyOperasjoner(), deps: [MøteprotokollVisKomponent]},
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteprotokollVisKomponent implements OnInit {
    static readonly ajsSelector = 'moeteprotokollVis';

    private protokolldokumentKortvisning = viewChild.required(DokumentKortvisningKomponent);
    private matDrawerContainer = viewChild.required(MatDrawerContainer);
    private dokumentDetaljerKomponent = viewChild(DokumentDetaljerKomponent);

    moeteId = input.required<MøteId>();

    moete: Signal<MøteModellDLM>;
    protokoll: Signal<ProtokollDetaljerModell>;
    saker: Signal<AgendaelementModellDLM[]>;
    deltakere: Signal<ProtokollførtMøtedeltakereModell>;
    skjemalaasInnloggetBruker: Signal<SkjemalåsModell | null>;

    signatarer = computed(() => ({
        interne: interneProtokollførteMøtedeltakere(this.deltakere()).filter(deltaker => deltaker.skalSignere),
        eksterne: eksterneProtokollførteMøtedeltakere(this.deltakere()).filter(ekstern => ekstern.skalSignere)
    } as MøteprotokollSignatarer));
    ikkeInnkalte = computed(() => this.deltakere().ikkeInnkalte.filter(deltaker => deltaker.skalSignere || erIkkeTomStreng(deltaker.kommentar)));
    redigeringMulig = computed(() => this.beregnRedigeringMulig(this.moete()));
    viserRepresentererKolonne = computed(() => interneProtokollførteMøtedeltakere(this.deltakere()).some(deltaker => deltaker.aksjeeierRepresentasjoner.length > 0));
    flerdagsmoete = computed(() => erFlerdagsmøte(this.protokoll()));

    transkripsjonInformasjon = computed(() => this.protokoll().transkripsjonInformasjon);
    transkripsjonsstatus = computed(() => this.beregnTranskripsjonsstatus(this.transkripsjonInformasjon(), this.moete()));

    viserProtokolldokumentdetaljer = signal(false);

    readonly transkripsjonPieKonfig: Partial<C3TodeltPaiKonfig> = {
        ikkePåbegyntPieBorderFarge: farge_grå_400_skagastølstind,
        ikkePåbegyntFarge: farge_profil_200_trondheim, // transparent farge gir riktig hover-effekt inni md-button
        andelFarge: farge_profil_500_bergen,
        restFarge: farge_profil_200_trondheim,
        fullførtFarge: farge_profil_500_bergen
    }

    constructor(private avhengigheter: MøteprotokollVisKomponentAvhengigheter,
                private brukerkontekst: BrukerkontekstTilbyder,
                private navigasjon: Navigasjon,
                @Inject(ajs_AjsUIRouterGlobals_DI_TOKEN) private ajsUIRouterGlobals: AjsUIRouterGlobals,
                @Inject(ajs_$rootScope_DI_TOKEN) ajsRootScope: AjsRootScopeService) {
        const møteIdObserverbar = toObservable(this.moeteId);

        this.moete = toSignal(møteIdObserverbar.pipe(switchMap(id => this.avhengigheter.hentMøte(id))), {initialValue: tomMøteModell()});
        this.protokoll = toSignal(møteIdObserverbar.pipe(switchMap(id => this.avhengigheter.hentProtokoll(id))), {initialValue: tomProtokollDetaljerModell()});
        this.saker = toSignal(møteIdObserverbar.pipe(switchMap(id => this.avhengigheter.hentSaker(id))), {initialValue: []});
        this.deltakere = toSignal(møteIdObserverbar.pipe(switchMap(id => this.avhengigheter.hentDeltakere(id))), {initialValue: tomProtokollførtMøtedeltakereModell()});
        this.skjemalaasInnloggetBruker = toSignal(toObservable(this.moete).pipe(
          switchMap(møte => (this.beregnRedigeringMulig(møte) ?
            from(this.avhengigheter.finnSkjemalåsEietAv(møte, this.finnMedlemKnytteTTilMøte(møte).id)) :
            of(null)))), {initialValue: null});

        //scroll til signering når bruker klikker på 'du har blitt bedt om å signere...' på møte-siden
        ajsRootScope.$on(MøteKontroller.eventer.scrollTilSignering, () => this.scrollTilSignering());
    }

    async ngOnInit() {
        if (this.ajsUIRouterGlobals.params['signer'] === 'true')
            this.scrollTilSignering();
    }

    async oppdaterInformasjon() {
        await this.avhengigheter.relastProtokoll(this.moete().id)
    }

    redigerProtokoll() {
        this.navigasjon.gåTilRedigerMøteProtokoll(this.moete().id);
    }

    redigerProtokollVisGenerertForslag() {
        this.navigasjon.gåTilRedigerMøteProtokoll(this.moete().id, true);
    }

    redigerProtokollGjenopprettSkjema() {
        this.navigasjon.gåTilRedigerMøteProtokoll(this.moete().id);
    }

    async protokollSignert(møtedeltaker: ProtokollførtMøtedeltakerModell) {
        //siden datalager for ProtokollførtMøtedeltakereModell ikke er automatisk oppdateres av protokoll-signerings-dialogen må her manuelt trigge relasting av data
        //merk at dette gjelder når innlogget bruker signerer, når annen bruker signerer vil datalageret bli oppdatert via modelloppdatering-mekanismen
        await this.avhengigheter.relastDeltakere(this.moeteId());
    }

    /** Viser detaljer for protokolldokumentet i høyre-del av vindu  */
    async visProtokolldokumentdetaljer() {
        this.viserProtokolldokumentdetaljer.set(true);
        if (!this.matDrawerContainer().end!.opened)
            await this.matDrawerContainer().end!.open();
        this.dokumentDetaljerKomponent()!.fokuser();
    }

    /** Skjuler detaljer for protokolldokumentet i høyre-del av vindu  */
    async skjulProtokolldokumentdetaljer() {
        await this.matDrawerContainer().end!.close();
        this.viserProtokolldokumentdetaljer.set(false);
    }

    gaaTilSak(sak: TynnSakModell) {
        this.navigasjon.gåTilSak(sak.id);
    }

    /** DelegerteDokumentDetaljerOperasjoner implementasjon - legges til DI-kontekst via @Component */
    delegerteDokumentDetaljerOperasjoner(): DelegerteDokumentDetaljerOperasjoner {
        return {
            //vi støtter ikke opprettelse av ny versjon av protokolldokument initiert av bruker
            registrerNyDokumentversjon: saksdokument => tomFunksjon(),

            åpneDokumentInline: saksdokument => {
                this.protokolldokumentKortvisning().aapneInline();
                return true;
            }
        }
    }

    /** DelegerteDokumentvisningOperasjoner implementasjon - legges til DI-kontekst via @Component */
    delegerteDokumentvisningOperasjoner(): DelegerteDokumentvisningOperasjoner {
        return {
            visSkjerming: dokumentversjon => {
                // ikke aktuelt for protokolldokument
            }, visSignatarer: dokumentversjon => {
                // ikke aktuelt for protokolldokument
            }
        };
    }

    /** DelegerteDokumentMenyOperasjoner implementasjon - legges til DI-kontekst via @Component.
     * Merk at vi forutsetter at dokumentDetaljer vises når disse kallene skjer, ved klikk på dokument-meny vil klikket på menyen ha ført til at
     * this.visDetaljerFor(..) allerede har blitt kalt, og følgelig vises dokumentDetaljer */
    delegerteDokumentMenyOperasjoner(): DelegerteDokumentMenyOperasjoner {
        return {
            visAlleVersjoner: async dokumentversjon => {
                await this.visProtokolldokumentdetaljer();
                //vent litt slik at dokumentinformasjon rekker å bli tegnet ut før vi scroller
                await timeoutSomPromise(100);
                this.dokumentDetaljerKomponent()!.fokuserVersjonerBlokk();
            },

            visSignatarer: async dokumentversjon => {
                // ikke aktuelt for protokolldokument
            },

            visSakerArkivdokumentBehandlesI: async dokumentversjon => {
                // ikke aktuelt for protokolldokument
            },

            visSkjerming: dokumentversjon => {
                // ikke aktuelt for protokolldokument
            },

            registrerNyDokumentversjon: dokumentversjon => {
                // ikke aktuelt for protokolldokument
            },

            tilgjengeligFunksjonalitet: dokumentversjon => {
                return {
                    rediger: false,
                    behandlesISaker: false,
                    favorittmarkering: false,
                    signering: false, //signering kan ikke styres via DokumentKortvisningKomponent for protokoll
                    versjonsvisning: true,
                    skjerming: false //selve protokolldokumentet kan ikke skjermes direkte
                };
            }
        };
    }

    // private hjelpemetoder

    private scrollTilSignering() {
        scrollTilSenter('#signaturfelter');
    }

    /**
     * Avgjør hvilken status transkripsjonen av møtet står i.
     *
     * Merk rekkefølgen: feilede transkripsjoner slår gjennom først, siden et generert forslag til protokoll
     * da bygger på et ufullstendig grunnlag og ikke bør presenteres som ferdig.
     * Bruker uten tilgang til forslag til protokoll får fortsatt se at transkriberingen pågår.
     */
    private beregnTranskripsjonsstatus(informasjon: ProtokollTranskripsjonInformasjonModell, møte: MøteModellDLM): Transkripsjonsstatus {
        if (informasjon.antallOpptak === 0) return 'ingenOpptak';
        //if (informasjon.antallOpptakTranskripsjonFeilet > 0) return 'transkripsjonFeilet';
        const harTilgang = harTilgangTilProtokollforslag(møte);
        if (harTilgang && informasjon.oppsummertMoetereferatTilgjengelig) return 'generertProtokollTilgjengelig';
        if ((informasjon.antallOpptakTranskribert + informasjon.antallOpptakTranskripsjonFeilet) < informasjon.antallOpptak) return 'transkriberingPaagaar';
        return harTilgang ? 'venterPaaGenerertProtokoll' : 'ingenTilgangTilProtokollforslag';
    }

    private beregnRedigeringMulig(møte: MøteModellDLM): boolean {
        return !møte.laastForRedigering &&
          this.brukerkontekst.autentisertBruker().inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, møte.eiendeGruppeId);
    }

    private finnMedlemKnytteTTilMøte(møte: MøteModellDLM): GruppeMedlemListeModell {
        return this.brukerkontekst.autentisertBruker().medlemRepresentasjonTilknyttet(møte.eiendeGruppeId);
    }
}

@Injectable()
export class MøteprotokollVisKomponentAvhengigheter {
    constructor(private protokollDatatjeneste: ProtokollDatatjeneste,
                private møteDatatjeneste: MøteDatatjeneste,
                private sakDatatjeneste: SakDatatjeneste,
                private protokollførtMøtedeltakereDatatjeneste: ProtokollførtMøtedeltakereDatatjeneste,
                private skjemalåsRessurs: SkjemalåsRessursClient) {
    }

    hentProtokoll(møteId: MøteId): Observable<ProtokollDetaljerModell> {
        return this.protokollDatatjeneste.hent(møteId);
    }

    /** Sørger for å oppdatere protokollinformasjon, vil føre til at
     * oppdaterte verdi blir levert via observable returnert av kall til {@link #hentProtokoll}  */
    async relastProtokoll(møteId: MøteId): Promise<void> {
        await this.protokollDatatjeneste.relast(møteId);
    }

    hentMøte(møteId: MøteId): Observable<MøteModellDLM> {
        return this.møteDatatjeneste.hentFraFraLokallagerSomObservable(møteId);
    }

    hentDeltakere(møteId: MøteId): Observable<ProtokollførtMøtedeltakereModell> {
        return this.protokollførtMøtedeltakereDatatjeneste.hent(møteId);
    }

    /** Sørger for å oppdatere protokollført deltakerinformasjon, vil føre til at
     * oppdaterte verdi blir levert via observable returnert av kall til {@link #hentDeltakere}  */
    async relastDeltakere(møteId: MøteId): Promise<void> {
        await this.protokollførtMøtedeltakereDatatjeneste.relast(møteId);
    }

    async finnSkjemalåsEietAv(møte: MøteModellDLM, kallendeMedlemId: MedlemId): Promise<SkjemalåsModell | null> {
        let låser = await this.skjemalåsRessurs.finn({
            gruppeId: møte.eiendeGruppeId,
            //vi har en liten type-utfordring knyttet til skjemalåsRessurs.finn - rotentitetId argumentet er egentlig en serialisert form av EntitetReferanseSpesifikasjon, derfor `as any`
            rotentitetId: enkodetEntitetReferanseSpesifikasjon(somEntitetReferanseSpesifikasjon(EntitetType.møte, møte.id)) as any,
            skjemaId: SkjemalåsSkjemaId.moeteprotokoll
        })
          .somPromiseVisMeldingVedFeil(i18n('Kunne ikke finnes skjemalåser for møte'));
        return låser.find(l => l.eier.id === kallendeMedlemId) ?? null;
    }

    hentSaker(møteId: MøteId): Observable<AgendaelementModellDLM[]> {
        //vi forutsetter at saker har blitt lastet vi kall til møteDatatjeneste.hent
        return this.sakDatatjeneste.finnTilknyttetMøteFraLokallager(møteId);
    }
}
